__turbopack_context__.v({
  "className": "open_sans_67976742-module__VW0ibW__className",
});
